import { Suspense, useEffect, useState } from 'react';

export type NoSSRSuspenseProps = React.PropsWithChildren<{
  fallback?: React.ReactNode;
}>;

export const NoSSRSuspense: React.FC<NoSSRSuspenseProps> = ({
  children,
  fallback,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return <>{fallback}</>;
  }

  return <Suspense fallback={fallback}>{children}</Suspense>;
};
